module.exports = (
  $scope,
  workflowTemplates,
  User
) ->
  $scope.workflowTemplates = workflowTemplates
  $scope.user = User
